/**
 * Dialogs - Progressive Enhancement für Dialog-Trigger
 *
 * Generisches Modul für alle nativen <dialog> Elemente im Theme.
 * Wird von Service-Dialogen, Angebote-Dialogen etc. genutzt.
 *
 * WCAG 2.1 AA konform:
 * - Ohne JS: Links führen zur Einzelseite
 * - Mit JS: Native <dialog> öffnet sich modal
 * - Focus wird automatisch vom <dialog> verwaltet
 * - ESC schließt Dialog (natives Verhalten)
 * - Klick auf Backdrop schließt Dialog
 *
 * Verwendung:
 * - Trigger: <a href="..." data-dialog-open="dialog-id">
 * - Dialog:  <dialog id="dialog-id" data-dialog>
 * - Close:   <button data-dialog-close>
 *
 * @package NWZ-Frankfurt
 * @since 2.0
 */

/**
 * Initialisiert alle Dialog-Trigger
 */
function initDialogs(): void {
    const triggers = document.querySelectorAll<HTMLAnchorElement>('[data-dialog-open]');

    if (triggers.length === 0) {
        return;
    }

    triggers.forEach((trigger: HTMLAnchorElement) => {
        const dialogId = trigger.getAttribute('data-dialog-open');
        if (!dialogId) return;

        const dialog = document.getElementById(dialogId) as HTMLDialogElement | null;
        if (!dialog) return;

        // Progressive Enhancement: Erst mit JS wird der Link zum Dialog-Trigger
        trigger.setAttribute('aria-haspopup', 'dialog');

        // Click Handler - verhindert Navigation, öffnet Dialog
        trigger.addEventListener('click', (e: MouseEvent) => {
            e.preventDefault();
            dialog.showModal();
        });

        // Space-Taste (da wir role="button"-ähnliches Verhalten wollen)
        trigger.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                dialog.showModal();
            }
        });
    });

    // Close-Buttons in allen Dialogen
    const closeButtons = document.querySelectorAll<HTMLButtonElement>('[data-dialog-close]');
    closeButtons.forEach((closeBtn: HTMLButtonElement) => {
        closeBtn.addEventListener('click', () => {
            const dialog = closeBtn.closest('dialog') as HTMLDialogElement | null;
            if (dialog) {
                dialog.close();
            }
        });
    });

    // Backdrop-Klick schließt Dialog
    const dialogs = document.querySelectorAll<HTMLDialogElement>('[data-dialog]');
    dialogs.forEach((dialog: HTMLDialogElement) => {
        dialog.addEventListener('click', (e: MouseEvent) => {
            if (e.target === dialog) {
                dialog.close();
            }
        });
    });
}

export { initDialogs };
